<template>
  <div id="organizationStructure" v-loading="loading">
    <div class="orgLeft" :style="myAutoContent">
      <el-container style="height:100%;width:100%">
        <el-header style="height:auto;margin-top:14px;margin-bottom:1px">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </el-header>
        <el-main style="height:100%;width:100%;padding-top:0">
          <div style="text-align:right;height:30px">
            <el-button size="max" type="text" @click="append()">
              <i class="fa fa-plus"></i>
            </el-button>
          </div>

          <el-tree
            :props="defaultProps"
            node-key="id"
            :data="areaData"
            accordion
            :expand-on-click-node="false"
            ref="tree1"
            @node-click="showAreaData"
            :filter-node-method="filterNode"
            :default-expand-all="false"
            :highlight-current="true"
            class="treeClass"
            :render-content="renderContent"
          ></el-tree>
        </el-main>
      </el-container>
    </div>

    <div class="orgRight" :style="myAutoContent">
      <div class="commonSearch" ref="commonSearchRef" style="height : 96%;">
        <div>
          <el-form ref="showAreaInfo" v-if="showAreaInfo" :model="showAreaInfo" label-width="80px">
            <el-form-item label="地区代码" style="margin-top:10px !important">
              <el-input v-model="showAreaInfo.code" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="地区名称" style="margin-top:10px !important">
              <el-input v-model="showAreaInfo.name" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="地区等级" style="margin-top:10px !important">
              <el-radio-group v-model="showAreaInfo.areaLevel">
                <el-radio v-if="showAreaInfo.areaLevel == 1" :label="1">省</el-radio>
                <el-radio v-if="showAreaInfo.areaLevel == 2" :label="2">市</el-radio>
                <el-radio v-if="showAreaInfo.areaLevel == 3" :label="3">区</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="父级代码" style="margin-top:10px !important">
              <el-input v-model="showAreaInfo.parentCode" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item
              v-if="showAreaInfo.disabled == 0 || 1"
              label="启用状态"
              style="margin-top:10px !important"
            >
              <el-tooltip
                v-if="showAreaInfo.disabled == 0 || 1"
                :content="'Switch value: ' + showAreaInfo.disabled"
                placement="top"
              >
                <el-switch
                  v-model="showAreaInfo.disabled"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="0"
                  :inactive-value="1"
                ></el-switch>
              </el-tooltip>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="saveOrUpdate()"
                style="width:100px;margin-top:10px"
              >保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabResize from "@/utils/TabResize.js";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [TabResize],
  components: {},
  mounted: function() {
    //初始化
    this.loading = true;
    this.getAreaData();
    this.$nextTick(() => {
      this.myAutoContent.height = this.myAutoContentHeight + "px";
      this.myTabHeight = this.myAutoContentInnerHeight + "px";
    });
  },
  computed: {},
  data() {
    return {
      myAutoContent: {
        height: "600px",
        "overflow-y": "auto"
      },
      defaultProps: {
        children: "lowerAreaVos",
        label: "name",
        isLeaf: "leaf"
      },
      areaData: [],
      areaForm: {},
      filterText: "",
      showAreaInfo: {},
      loading: false,
      isDisabled: false
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree1.filter(val);
    }
  },
  methods: {
    getAreaData() {
      if (this.loading === false) {
        this.loading = true;
      }
      SettingApi.getClass()
        .getAreaInfo()
        .then(res => {
          if (res) {
            this.areaData = res.data.data;
            this.showAreaInfo = this.areaData[0];
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    showAreaData(e) {
      this.showAreaInfo = e;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    saveOrUpdate() {
      this.loading = true;
      SettingApi.getClass()
        .saveOrUpdateArea(this.showAreaInfo)
        .then(res => {
          if (res && res.data.code == this.$constant.BIZ_RESPONSE_CODE) {
            this.getAreaData();
            this.$message.success("操作成功！");
          } else {
            this.$message.error(res.data.msg);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    append(e) {
      let lowerArea = {
        name: "新增地区",
        parentCode: 0,
        disabled: 0,
        areaLevel: 1,
        lowerAreaVos: []
      };
      if (e) {
        if (!e.code) {
          this.$message.error("当前节点没有地区编码，无法增加子级地区");
          return;
        }
        if(e.disabled == 1){
           this.$message.error("当前节点被禁用，无法增加子级地区");
          return;
        }
        lowerArea.areaLevel = e.areaLevel + 1;
        lowerArea.parentCode = e.code;
        if (!e.lowerAreaVos) {
          this.$set(e, "lowerAreaVos", []);
        }
        e.lowerAreaVos.push(lowerArea);
      } else {
        this.areaData.push(lowerArea);
      }
    },

    remove(node, data) {
      if (data.lowerAreaVos != null && data.lowerAreaVos.length > 0) {
        this.$message.error("存在子节点，无法删除。");
        return;
      }
      this.$confirm("此操作将永久删除该区域以及其子级所有区域, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let param = [data.id];
        SettingApi.getClass()
          .deleteArea(param)
          .then(res => {
            if (res && res.data.code == this.$constant.BIZ_RESPONSE_CODE) {
              const parent = node.parent;
              const children = parent.data.lowerAreaVos || parent.data;
              const index = children.findIndex(d => d.code === data.code);
              children.splice(index, 1);
              this.$message.success("删除成功！");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      });
    },

    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span style="position: absolute;right:1%;margin-top: -3%;">
            <el-button
              size="max"
              type="text"
              on-click={() => this.append(data)}
            >
              <i class="fa fa-plus"></i>
            </el-button>
            <el-button
              size="max"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              <i class="fa fa-minus"></i>
            </el-button>
          </span>
        </span>
      );
    }
  }
};
</script>


<style lang="stylus" scoped>
#organizationStructure {
  width: 100%;

  .orgLeft {
    width: 250px;
    float: left;
    margin-left: $content-margin-left;
    background-color: white;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
  }

  .orgRight {
    margin-top: $content-margin-top;
    margin-right: $content-margin-right;
    background-color: white;
    width: auto;
    margin-left: 260px;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
  }

  .custom-tree-node {
    font-size: $default-font;
  }

  .btnColor {
    color: $theme-color;
  }

  .treeClass >>> .el-tree-node__children {
    overflow: inherit !important;
  }

  .treeClass >>> .el-tree-node__content {
    width: 100%;
  }
}
</style>

